module.exports = __webpack_public_path__ + "img/wfntsa.212634fa.png";